import { useCallback } from "react";

import useClient from "hooks/useClient";

const useCancelService = (): {
  cancelService: ({ optionId, serviceId }: { optionId: string; serviceId: string }) => Promise<number>;
} => {
  const { client } = useClient();

  const cancelService = useCallback(
    async ({ optionId, serviceId }: { optionId: string; serviceId: string }) => {
      const { status } = await client({
        method: "put",
        url: `/option/${optionId}/request-service/${serviceId}/cancel`,
      });
      return status;
    },
    [client]
  );

  return { cancelService };
};

export default useCancelService;
